import { MessageCircle } from 'lucide-react';
import { siteInfo } from '../data/mock';

export const WhatsAppButton = () => {
  const whatsappUrl = `https://wa.me/${siteInfo.whatsapp}?text=Hi%20Scaleup%20Academy!%20I%27m%20interested%20in%20your%20courses.%20Please%20share%20more%20details.`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] flex items-center justify-center shadow-lg shadow-[#25D366]/30 hover:scale-110 hover:shadow-xl hover:shadow-[#25D366]/40 transition-all duration-300 group"
    >
      <MessageCircle size={26} className="text-white" />
      <span className="absolute right-full mr-3 px-3 py-1.5 rounded-lg bg-[rgb(26,28,30)] text-white text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none border border-white/10">
        Chat with us
      </span>
    </a>
  );
};
